import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {HTH} from "../HTH";
import {gsap} from "gsap"
import {HTHHelper} from "../utils/HTHHelper";
import {HTHSound} from "../sound/HTHSound";

export class HTHMaxWinSymbol extends HTHSymbol {
    private _currentStateSpine: PIXI.spine.Spine;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.MAX_WIN) {
        super(symbolData, state);
        this.init(symbolData);

    }

    public getSpineAnimation(symData: ISymbolData): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.addImage();
        this.symbolState = HTHSymbolStates.BLANK;
        return tl;
    }

    public addImage(): void {
        this._currentStateSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("maxwinSymbol"))
        this._currentStateSpine.visible = true;
        this._currentStateSpine.state.setAnimation(0, "idle", false);
        this._currentStateSpine.scale.set(0.98, 0.98);
        this.addChild(this._currentStateSpine);
    }

    public init(symData: ISymbolData): HTHMaxWinSymbol {
        this.getSpineAnimation(symData);
        return this;
    }

    public addMaxWinEffect(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(HTHHelper.playSpineWithTimeline(this._currentStateSpine, 0, "win"));
        return tl;
    }

    public removeAndDestroy(): void {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }


}